import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c25fca90&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/common/upi-payment/upi-payment.scss?vue&type=style&index=0&id=c25fca90&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25fca90",
  null
  
)

export default component.exports